import React from 'react';
import './HoroscopesEdge.scss';
import { HoroscopesIcon } from '../HoroscopesIcon/HoroscopesIcon';
import { HoroscopeIconCategory, HoroscopeIconType, } from '../HoroscopesIcon/HoroscopesIcon-Constants';
import { useTranslation } from 'react-i18next';

interface HoroscopesEdgeProps {
  icon?: HoroscopeIconType | HoroscopeIconCategory;
  sign: string;
  text: string;
}

export const HoroscopesEdge: React.FC<HoroscopesEdgeProps> = ({
  icon,
  sign,
  text,
}) => {
  const { t, i18n } = useTranslation();

  const getDisplayName = (signType: HoroscopeIconType): string => {
    return signType.charAt(0).toUpperCase() + signType.slice(1);
  };

  return (
    <div className="horoscopes-edge">
      <div className="horoscopes-edge__graphic">
        <HoroscopesIcon
          type={icon || HoroscopeIconType.aries}
          width={200}
          height={200}
        />
      </div>
      <div className="horoscopes-edge__content">
        <h2 className="horoscopes-edge__title title-md">
          {getDisplayName(t(sign.toString().toLowerCase()), sign.toString())}
        </h2>
        <p className="horoscopes-edge__text body-sm">{text}</p>
      </div>
    </div>
  );
};
